var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidelineDOs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59375 0C4.6233 0 0.59375 4.02955 0.59375 9C0.59375 13.9705 4.6233 18 9.59375 18C14.5642 18 18.5938 13.9705 18.5938 9C18.5938 4.02955 14.5642 0 9.59375 0ZM13.4948 7.47818C13.5667 7.39607 13.6214 7.30042 13.6557 7.19687C13.69 7.09331 13.7033 6.98393 13.6947 6.87517C13.6861 6.76641 13.6559 6.66046 13.6058 6.56356C13.5556 6.46666 13.4866 6.38076 13.4028 6.31092C13.319 6.24107 13.2221 6.1887 13.1177 6.15687C13.0134 6.12504 12.9037 6.11441 12.7952 6.12559C12.6867 6.13677 12.5815 6.16954 12.4858 6.22197C12.3901 6.27441 12.3059 6.34545 12.2381 6.43091L8.71993 10.6519L6.89948 8.83064C6.74517 8.6816 6.53849 8.59913 6.32397 8.60099C6.10944 8.60286 5.90423 8.68891 5.75253 8.8406C5.60084 8.9923 5.51479 9.19751 5.51293 9.41204C5.51106 9.62656 5.59353 9.83323 5.74257 9.98755L8.19711 12.4421C8.27751 12.5224 8.37375 12.5851 8.47973 12.6262C8.5857 12.6673 8.69907 12.6859 8.81261 12.6807C8.92615 12.6756 9.03737 12.6468 9.13918 12.5963C9.24099 12.5458 9.33115 12.4746 9.40393 12.3873L13.4948 7.47818Z",
    fill: "#0EC657"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelineDOs);
export default __webpack_public_path__ + "static/media/guideline_DOs.bfa2c731.svg";
export { ForwardRef as ReactComponent };